import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProgressStages, saveProgressStages, ProgressStage } from "../../api/admin";
import { getUser, isSuperAdmin, ClientPrincipal } from "../../auth/user";

export default function ProgressStagesPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState<ClientPrincipal | null>(null);
  const [stages, setStages] = useState<ProgressStage[]>([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [savedAt, setSavedAt] = useState<string | null>(null);

  useEffect(() => { getUser().then(setUser); }, []);
  useEffect(() => { getProgressStages().then((s) => setStages(s.map((x) => ({ ...x })))); }, []);

  if (user && !isSuperAdmin(user)) {
    return <div className="banner-error">Super admin required.</div>;
  }

  const move = (i: number, dir: -1 | 1) => {
    setStages((arr) => {
      const j = i + dir;
      if (j < 0 || j >= arr.length) return arr;
      const next = arr.slice();
      [next[i], next[j]] = [next[j], next[i]];
      return next;
    });
  };

  const onSave = async () => {
    setError(null);
    setSaving(true);
    try {
      const saved = await saveProgressStages(stages);
      setStages(saved.map((s) => ({ ...s })));
      setSavedAt(new Date().toLocaleTimeString());
    } catch (e) {
      setError(e instanceof Error ? e.message : "Failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="admin-page-head">
        <h1>Progress stages</h1>
        <button type="button" className="btn-secondary" onClick={() => navigate("/admin")}>Done</button>
      </div>
      <p className="hint">These stages appear as togglable progress markers on each submission. Reorder or rename to match your workflow.</p>
      <div className="card">
        <ol className="ordered-list">
          {stages.map((s, i) => (
            <li key={s.id || i}>
              <input
                type="text"
                value={s.label}
                onChange={(e) => setStages((arr) => arr.map((x, j) => (j === i ? { ...x, label: e.target.value } : x)))}
                placeholder="Stage label, e.g. Set up in Procore"
                className="ol-input"
              />
              <span className="ol-actions">
                <button type="button" onClick={() => move(i, -1)} title="Move up">↑</button>
                <button type="button" onClick={() => move(i, 1)} title="Move down">↓</button>
                <button type="button" onClick={() => setStages((arr) => arr.filter((_, j) => j !== i))} title="Remove">×</button>
              </span>
            </li>
          ))}
        </ol>
        <div className="actions">
          <button type="button" className="btn-secondary" onClick={() => setStages((arr) => [...arr, { id: `stage_${Date.now()}`, label: "" }])}>+ Add stage</button>
          <button type="button" className="btn-save" onClick={onSave} disabled={saving}>{saving ? "Saving…" : "Save"}</button>
          {savedAt && <span className="hint">Saved at {savedAt}</span>}
          {error && <span className="banner-error" style={{ display: "inline-block" }}>{error}</span>}
        </div>
      </div>
    </>
  );
}
